import { defineComponent as p, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as V, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as M } from "../hooks/useScalarIcon.js";
const Z = { key: 0 }, m = { key: 1 }, f = { key: 2 }, A = { key: 3 }, k = { key: 4 }, h = { key: 5 }, w = {
  name: "ScalarIconCaretLineLeft"
}, L = /* @__PURE__ */ p({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = M(s);
    return (i, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      V(i.$slots, "default"),
      e(n) === "bold" ? (l(), o("g", Z, t[0] || (t[0] = [
        a("path", { d: "M200.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L129,128ZM72,36A12,12,0,0,0,60,48V208a12,12,0,0,0,24,0V48A12,12,0,0,0,72,36Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (l(), o("g", m, t[1] || (t[1] = [
        a("path", {
          d: "M192,48V208l-80-80Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M195.06,40.61a8,8,0,0,0-8.72,1.73l-80,80a8,8,0,0,0,0,11.32l80,80A8,8,0,0,0,200,208V48A8,8,0,0,0,195.06,40.61ZM184,188.69,123.31,128,184,67.31ZM80,48V208a8,8,0,0,1-16,0V48a8,8,0,0,1,16,0Z" }, null, -1)
      ]))) : e(n) === "fill" ? (l(), o("g", f, t[2] || (t[2] = [
        a("path", { d: "M200,48V208a8,8,0,0,1-13.66,5.66l-80-80a8,8,0,0,1,0-11.32l80-80A8,8,0,0,1,200,48ZM72,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,72,40Z" }, null, -1)
      ]))) : e(n) === "light" ? (l(), o("g", A, t[3] || (t[3] = [
        a("path", { d: "M196.24,203.76a6,6,0,1,1-8.48,8.48l-80-80a6,6,0,0,1,0-8.48l80-80a6,6,0,0,1,8.48,8.48L120.49,128ZM72,42a6,6,0,0,0-6,6V208a6,6,0,0,0,12,0V48A6,6,0,0,0,72,42Z" }, null, -1)
      ]))) : e(n) === "regular" ? (l(), o("g", k, t[4] || (t[4] = [
        a("path", { d: "M197.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L123.31,128ZM72,40a8,8,0,0,0-8,8V208a8,8,0,0,0,16,0V48A8,8,0,0,0,72,40Z" }, null, -1)
      ]))) : e(n) === "thin" ? (l(), o("g", h, t[5] || (t[5] = [
        a("path", { d: "M194.83,205.17a4,4,0,0,1-5.66,5.66l-80-80a4,4,0,0,1,0-5.66l80-80a4,4,0,1,1,5.66,5.66L117.66,128ZM72,44a4,4,0,0,0-4,4V208a4,4,0,0,0,8,0V48A4,4,0,0,0,72,44Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  L as default
};
